import { get, post } from './axios.js'

/**
 * 메뉴 목록 조회 - /menu/menuList
 * @param {Object} params
 * @property {string} params.enable_yn - 사용여부
 * @property {string} params.menu_id - 메뉴 id
 * @property {string} params.menu_nm - 메뉴명
 * @property {string} params.scren_id - 화면id
 * @returns
 */
export async function menuList(params = {}) {
  try {
    const result = await post('/menu/menuList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 메뉴 등록/수정 - /menu/menuEdit
 * @param {Object} params
 * @property {string} params.menu_id - 메뉴 id
 * @property {string} params.upper_menu_id - 부모 메뉴 id
 * @property {string} params.menu_nm - 메뉴명
 * @property {string} params.scren_id - 화면id
 * @property {string} params.menu_url - 화면 경로
 * @property {string} params.menu_sort - 메뉴순서
 * @property {string} params.enable_yn - 사용여부
 * @property {string} params.descrpt - 설명
 * @property {string} params.ss_user_id - 로그인 유저 id
 * @returns
 */
export async function menuEdit(params = {}) {
    try {
      const result = await post('/menu/menuEdit', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * 메뉴 삭제 - /menu/menuDelete
 * @param {Object} params
 * @property {string} params.upd_id - 수정자
 * @property {string} params.menu_id - 메뉴 id
 * @property {string} params.scren_id - 화면 id
 * @returns
 */
export async function menuDelete(params = {}) {
    try {
      const result = await post('/menu/menuDelete', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * 메뉴 등록/수정 (중복?) - /menu/menuTreeEdit
 * @param {Object} params
 * @property {string} params.menu_id - 메뉴 id
 * @property {string} params.upper_menu_id - 상위메뉴id
 * @property {string} params.menu_nm - 메뉴명
 * @property {string} params.scren_id - 화면 id
 * @property {string} params.menu_url - 화면 경로
 * @property {string} params.menu_sort - 메뉴순서
 * @property {string} params.enable_yn - 사용여부
 * @property {string} params.ss_user_id - 로그인 유저 id
 * @returns
 */
export async function menuTreeEdit(params = {}) {
    try {
      const result = await post('/menu/menuTreeEdit', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}